var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-menu-item", { attrs: { index: "" + _vm.model.id } }, [
    _c("span", [_vm._v(_vm._s(_vm.printTitle(_vm.model)))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }